var map = {
	"./circle_black.svg": 922,
	"./circle_blue.svg": 923,
	"./ellipse_black.svg": 924,
	"./france.svg": 264,
	"./highlighted_yellow.svg": 925,
	"./icons/_info.svg": 926,
	"./icons/add_prod.svg": 267,
	"./icons/add_prodOLD.svg": 927,
	"./icons/ask.svg": 928,
	"./icons/facebook.svg": 38,
	"./icons/hatchef.svg": 53,
	"./icons/icone/_info.svg": 929,
	"./icons/icone/hatchef.svg": 930,
	"./icons/icone/info.svg": 931,
	"./icons/icone/play.svg": 932,
	"./icons/icone/plus.svg": 933,
	"./icons/icone/specs.svg": 934,
	"./icons/icone/world.svg": 935,
	"./icons/index-icon-bookmark.svg": 936,
	"./icons/index-icon.svg": 937,
	"./icons/info.svg": 55,
	"./icons/markers-SVG/ask.svg": 938,
	"./icons/markers-SVG/info.svg": 939,
	"./icons/markers-SVG/list.svg": 940,
	"./icons/markers-SVG/recipe.svg": 941,
	"./icons/markers-SVG/web.svg": 942,
	"./icons/play.svg": 46,
	"./icons/play_ip.svg": 943,
	"./icons/plus.svg": 49,
	"./icons/promo.svg": 54,
	"./icons/promo2.svg": 944,
	"./icons/promo3.svg": 945,
	"./icons/promo_10.svg": 946,
	"./icons/promo_classic.svg": 947,
	"./icons/remove_prod.svg": 268,
	"./icons/remove_prodOLD.svg": 948,
	"./icons/shop_list.svg": 269,
	"./icons/specs.svg": 47,
	"./icons/whatsapp.svg": 39,
	"./icons/world.svg": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 921;